import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs/Observable';
import { changePasswordMutation, changePasswordWithSecurityToken, loginUserMutation, refreshTokenMutation, sendEmailForRecoverPasswordMutation } from '../../../graph-ql/mutations';
import { userLoggedQuery } from '../../../graph-ql/queries';

@Injectable()
export class UserService {

  constructor(private readonly apollo: Apollo) {
  }

  // activate$(token: string, uuid: string): Observable<any> {
  //   return this.apollo
  //     .mutate({
  //       mutation: activateUserMutation,
  //       variables: {
  //         activateUserRequest: {
  //           token: token,
  //           uuid: uuid,
  //         },
  //       },
  //     });
  // }

  login$(email: string, password: string, userAgent: string): Observable<any> {
    return this.apollo
      .mutate({
        mutation: loginUserMutation,
        variables: {
          loginUserInput: {
            email,
            password,
            userAgent
          }
        }
      });
  }

  changePassword$(password: string): Observable<any> {
    return this.apollo
      .mutate({
        mutation: changePasswordMutation,
        variables: {
          input: {
            password
          }
        }
      });
  }

  changePasswordWithSecurityToken$(password: string, token: string): Observable<any> {
    return this.apollo
      .mutate({
        mutation: changePasswordWithSecurityToken,
        variables: {
          input: {
            password,
            token
          }
        }
      });
  }

  sendEmailForRecoverPassword$(email: string): Observable<any> {
    return this.apollo
      .mutate({
        mutation: sendEmailForRecoverPasswordMutation,
        variables: {
          input: {
            email
          }
        }
      });
  }

  refreshJWTToken$(email: string): Observable<any> {
    return this.apollo
      .mutate({
        mutation: refreshTokenMutation,
        variables: {
            input: email,
        },
      });
  }

  userLogged$(): Observable<any> {
    return this.apollo
      .query({
        query: userLoggedQuery
      });
  }

}
